import { render, staticRenderFns } from "./MensajeForm.vue?vue&type=template&id=eea4e49c&scoped=true&"
import script from "./MensajeForm.vue?vue&type=script&lang=ts&"
export * from "./MensajeForm.vue?vue&type=script&lang=ts&"
import style0 from "./MensajeForm.vue?vue&type=style&index=0&id=eea4e49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea4e49c",
  null
  
)

export default component.exports